// extracted by mini-css-extract-plugin
export default {"element":"element--4-r7","title":"title--xgAa","inputs":"inputs--mRVW","from-input":"from-input--TbzI","to-input":"to-input--05NY"};